import { planInfo, planOf } from "@/lib/plans";
import { L } from "@/i18n";

export const PlanBadge = ({ user }) => {
  const key = planOf(user);
  if (!key) return <span className="font-mono text-xs text-slate-600" title={L("The API does not return this user's plan", "A API não devolve o plano deste utilizador")}>—</span>;
  const p = planInfo(key);
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 font-mono text-[11px]"
      style={{ color: p.color, borderColor: `${p.color}55`, background: `${p.color}14` }}
    >
      {p.label}
    </span>
  );
};
